import React from "react";
import SwipeRow from "../ui/SwipeRow";

// One task: a big round checkbox and the text. Tap the text to edit; swipe left to delete.
export default function TaskRow({ task, onToggle, onOpen, onDelete }) {
  return (
    <SwipeRow onTap={() => onOpen(task)} onDelete={() => onDelete(task)} deleteLabel={`Delete task: ${task.text}`}>
      <div className={`tk-line${task.completed ? " is-done" : ""}`}>
        <button
          type="button"
          role="checkbox"
          aria-checked={task.completed}
          aria-label={task.completed ? `Mark not done: ${task.text}` : `Mark done: ${task.text}`}
          className="tk-cb"
          data-row-nodrag
          onClick={(e) => {
            e.stopPropagation();
            onToggle(task.id);
          }}
        >
          <span className="tk-cb-dot" />
        </button>
        <span className="tk-text">{task.text}</span>
      </div>
    </SwipeRow>
  );
}
